import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { selectUser } from 'entities/user/selectors';
import User from 'entities/user/model';
import { RenderMachine, StepComponentProps } from 'components/Flow/RenderMachine';

import { dataCaptureMachine } from './machine';
import { NonprofitOnboardingDataCaptureFlowContext } from './context';

export const DataCaptureStep = (props: StepComponentProps & { id?: string }) => {
  const user = useSelector(selectUser) as User;

  const dispatch = useDispatch();

  if (!user?.organization) {
    return null;
  }
  const isCompany = user.organization?.isCompany();
  if (isCompany) {
    return null;
  }

  return (
    <RenderMachine
      machine={dataCaptureMachine}
      options={{
        context: {
          dispatch,
          organization: user?.organization,
          privileges: user?.privileges,
          dismissedSteps: props.standaloneMode ? {} : user?.get('onboarding')?.toJS(),
          allowedSteps: props.state?.context?.allowedSteps,
          error: null,
        },
        actions: {
          handleFinal: () => props.send('NEXT'),
        },
        id: props.id,
      }}
      context={NonprofitOnboardingDataCaptureFlowContext}
    />
  );
};
